export const containsImg = (html: string | undefined) => {
  if (!html) {
    return false;
  }

  const div = document.createElement("div");
  div.innerHTML = html;
  return !!div.querySelector("img");
};
